"use client";

import { useLayoutEffect, useState } from "react";

import { useStore } from "@/store";

import type { ServerViewState } from "@/store/ViewStore";

/**
 * Applies the server-derived view state before the children's first render,
 * so SSR and hydration render from the same values, then applies the
 * window-dependent layout once the tree has hydrated.
 */
export function ViewProvider({
  initialViewState,
  children,
}: {
  initialViewState: ServerViewState;
  children: React.ReactNode;
}) {
  const { view } = useStore();
  useState(() => view.initFromServerState(initialViewState));

  useLayoutEffect(() => {
    view.applyClientLayout();
  }, [view]);

  return <>{children}</>;
}
